// import BASE_API from '@/api/dataBase';

export const searchColumns = (ctx, isCustomerContract = true) => {
  return [
    // {
    //   prop: 'createDepartmentNo',
    //   name: '创建组织',
    //   type: 'treeSelect',
    //   apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
    //   multiple: true,
    //   isName: true, // 是否返回名字
    //   returnType: 'object', // 全部返回当前对象
    //   changeMethod: 'createDeptChange',
    //   ref: 'createDepartmentName',
    //   // isLine: true,
    //   // tipMessage: 'hello', // 默认选中的
    //   apiData: {
    //     tenantCode: ctx.userInfo.tenantCode,
    //     adminFlag: ctx.userInfo.adminFlag,
    //     // selfCompanyDepartmentTreeFlag: true,
    //   },
    // },
    // {
    //   prop: 'saleDepartmentNo',
    //   name: '销售组织',
    //   type: 'treeSelect',
    //   apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
    //   multiple: true,
    //   isName: true, // 是否返回名字
    //   returnType: 'object', // 全部返回当前对象
    //   changeMethod: 'saleDeptChange',
    //   ref: 'saleDepartmentName',
    //   // currentValue: '7024', // 默认选中的
    //   apiData: {
    //     tenantCode: ctx.userInfo.tenantCode,
    //     adminFlag: ctx.userInfo.adminFlag,
    //     // selfCompanyDepartmentTreeFlag: true,
    //   },
    // },
    // {
    //   name: '签约抬头',
    //   prop: 'signTitle',
    //   multiple: true,
    //   type: 'dict',
    //   dictType: 'INTERMODALITY-SIGN-TITLE',
    // },
    {
      name: '纸质合同编号',
      prop: 'paperContractNumber',
      type: 'input',
    },
    {
      prop: isCustomerContract ? 'customerName' : 'supplierName',
      type: 'input',
      name: isCustomerContract ? '客户名称' : '供方名称',
    },
    {
      prop: 'platformCompanyCode',
      name: '平台公司',
      type: 'select',
      options: ctx.companyList,
      filterable: true,
      label: 'personCompanyName',
      value: 'personCompanyCode',
      changeMethod: 'platformCompanyChange',
    },
    {
      prop: 'businessDepartmentCode',
      name: '业务部门',
      type: 'select',
      options: ctx.departmentList,
      changeMethod: 'businessDepartmentChange',
      // disabled: true,
      // type: 'select',
      // disabled: !ctx.queryData.platformCompanyName,
      // clearable: true,
      // filterable: true,
      // options: ctx.curDepartmentList,
      // value: 'createDepartmentCode',
      // label: 'createDepartmentName',
      // multiple: true,
    },
    ...(!isCustomerContract
      ? [
          {
            prop: 'usableDepartmentList',
            name: '可使用部门',
            type: 'select',
            multiple: true,
            options: ctx.departmentList,
            changeMethod: 'usableDepartmentChange',
          },
        ]
      : []),
    {
      name: '项目编号',
      prop: 'projectCode',
      type: 'input',
    },
    {
      name: '合同编号',
      prop: 'contractCode',
      type: 'input',
    },
    {
      name: '经办人员',
      prop: 'chargePersonId',
      type: 'searchTableSpec',
      searchType: 'personnel',
      changeMethod: 'chargePersonChange',
      isNeedMultipleValue: true,
    },
    {
      name: '合同名称',
      prop: 'contractName',
      type: 'input',
    },
    {
      prop: 'serviceTypeName',
      type: 'dict',
      dictType: 'INTERMODALITY-SERVICE-TYPE',
      multiple: true,
      name: '合同产品服务',
      changeMethod: 'serviceChange',
    },
    {
      name: '合同类型',
      type: 'select',
      prop: 'contractType',
      options: [
        { value: '0', label: '常规合同' },
        { value: '1', label: '结算条款' },
      ],
      multiple: true,
      changeMethod: 'contractTypeChange',
    },
    {
      name: '合同状态',
      type: 'dict',
      dictType: 'intermodality_contract_statu',
      prop: 'contractStatus',
      changeMethod: 'contractStatusChange',
      multiple: true,
    },
    // {
    //   prop: 'platformCompanyCode',
    //   name: '平台公司',
    //   type: 'ajaxSelect',
    //   apiUrl: BASE_API.LISTDATA_SERECHCOMPANY + `/${ctx.userInfo.tenantCode}`,
    //   method: 'get',
    //   valueType: 'object',
    //   changeMethod: 'platformCompanyChange',
    // },
    // {
    //   prop: 'platformCompanyName',
    //   name: '平台公司',
    //   type: 'dict',
    //   dictType: 'INTERMODALITY-PLATFORM-COMPANY',
    //   changeMethod: 'platformCompanyChange',
    // },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
    },
    {
      prop: 'startContractSignDate',
      name: '合同签订日期起',
      type: 'startDaterangePicker',
    },
    {
      prop: 'endContractSignDate',
      name: '合同签订日期至',
      type: 'endDaterangePicker',
    },
    {
      prop: 'startContractEffectDate',
      name: '合同起始时间起',
      type: 'startDaterangePicker',
    },
    {
      prop: 'endContractEffectDate',
      name: '合同起始时间至',
      type: 'endDaterangePicker',
    },
    {
      prop: 'startContractExpireDate',
      name: '合同终止时间起',
      type: 'startDaterangePicker',
    },
    {
      prop: 'endContractExpireDate',
      name: '合同终止时间至',
      type: 'endDaterangePicker',
    },
    {
      prop: 'hasExpirationDate',
      name: '是否规定失效日期',
      type: 'select',
      options: [
        { value: '0', label: '是' },
        { value: '1', label: '否' },
      ],
    },
  ];
};

export const defaultTableColumns = (isCustomerContract = true) => {
  return [
    {
      field: 'contractCode',
      title: '合同编号',
      width: '140',
    },
    {
      field: 'contractSignDate',
      title: '合同签订时间',
      width: '140',
    },
    {
      field: 'paperContractNumber',
      title: '纸质合同编号',
      width: '140',
    },
    {
      field: 'contractName',
      title: '合同名称',
      width: '140',
    },
    {
      field: 'projectCode', //
      title: '项目编号',
      width: '140',
    },
    {
      field: 'projectName',
      title: '项目名称',
      width: '140',
    },
    {
      field: 'oaUrl',
      title: '审批详情',
    },
    {
      field: 'createDepartmentName',
      title: '创建组织',
      width: '140',
    },
    // {
    //   field: 'saleDepartmentName',
    //   title: '销售组织',
    //   width: '140',
    // },
    // {
    //   field: 'signTitle',
    //   title: '签约抬头',
    //   width: '140',
    // },
    {
      field: 'platformCompanyName',
      title: '平台公司',
      width: '140',
    },
    {
      field: 'businessDepartmentName',
      title: '业务部门',
      width: '140',
    },
    ...(!isCustomerContract
      ? [
          {
            field: 'usableDepartmentName',
            title: '可使用部门',
            width: '140',
          },
        ]
      : []),
    {
      field: isCustomerContract ? 'customerName' : 'supplierName',
      title: isCustomerContract ? '客户名称' : '供方名称',
      width: '140',
    },
    {
      field: 'chargePersonName',
      title: '经办人员',
      width: '140',
    },
    {
      field: 'contractType',
      title: '合同类型',
      width: '140',
    },
    {
      field: 'contractTotalAmount',
      title: '合同金额',
      width: '140',
    },
    {
      field: 'serviceTypeName',
      title: '合同产品服务',
      width: '140',
    },
    {
      field: 'contractEffectDate',
      title: '合同起始时间',
      width: '140',
    },
    {
      field: 'contractExpireDate',
      title: '合同终止时间',
      width: '140',
    },
    {
      field: 'contractStatus',
      fixed: 'right',
      title: '合同状态',
      width: '80',
    },
  ];
};
